import React from 'react';
import { createPortal } from 'react-dom';
import WorkspaceFilterHost from './WorkspaceFilterHost';

function WorkspaceFilterPortal({
  container,
  open = true,
  filterBar,
  summaryLabels = [],
  exportFilters = [],
  label = 'Filters',
  maxControlWidth = 220,
  disabled = false,
}) {
  if (!container) return null;

  return createPortal(
    <WorkspaceFilterHost
      open={open}
      filterBar={filterBar}
      summaryLabels={summaryLabels}
      exportFilters={exportFilters}
      label={label}
      hideLabel={container.dataset.workspaceHideFilterLabel === 'true'}
      maxControlWidth={maxControlWidth}
      disabled={disabled}
    />,
    container
  );
}

export default WorkspaceFilterPortal;
